<script lang="ts">
	import ImageCard from '../Card/ImageCard.svelte';

	// Put in 6 images to show in the image box.
	export let imageUrls: [string, string, string, string, string, string];
</script>

<div class="image-grid">
	{#each imageUrls as imageUrl, i}
		<ImageCard index={i + 1} imageSrc={imageUrl} />
	{/each}
</div>

<style>
	.image-grid {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
		grid-template-rows: 1fr 1fr;
		grid-template-areas:
			'image1 image1 image1 image1 image1 image2 image2 image3 image3'
			'image4 image4 image4 image5 image5 image5 image6 image6 image6';
		grid-gap: 1rem;
	}
</style>
